import { createSessionSwrScope, type SwrKey } from '@/core/lib/swr/swr.key'
import { STUDIO_READ_POLICY } from '@/features/studio-renew/lib/studio-read'

export function creatorQuestSwrKey(epoch: string): SwrKey {
  return [
    '/creator/me/quest/',
    { scope: createSessionSwrScope(epoch), requestPolicy: STUDIO_READ_POLICY },
  ]
}
